// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doctor-section {
    padding: 32px;
    text-align: center;
    background-color:white;
}
.dt-title-content {
    margin: 0 0 64px 0;
}
.dt-title {
    font-family: 'Inter', sans-serif;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: .7px;
}
.dt-title > span {
    position: relative;

}
.dt-title span::before {
    content: '';
    position: absolute;
    width: 64%;
    height: 4px;
    background-color: #9D2553;
    border-radius: 8px;
    left: 18%;
    bottom: -12px;
}
.dt-description {
    margin: 65px 295px ;
    text-align: center;
    color: rgb(77, 75, 75);
    font-family: Inter , sans-serif;
    font-size: 20px;
    letter-spacing: .8px;
    line-height: 1.8rem;
}
/* Doctor Cards */
.dt-cards-content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 32px;
}
.dt-card {
    width: 332px;
    height: 400px;
    gap: 32px;
    text-align: left;
    font-family: 'Rubik', sans-serif;
}
.dt-card-img {
    width: 90%;
    height: 275px;
    background-position: center;
    border-radius: 20px;
}
.dt-card-name {
    margin: 12px 0 0 0;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: .7px;
}
.dt-card-phone {
    margin: 6px 0 8px;
    color: #494949;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    letter-spacing: .7px;
}
.dt-card-mail {
    margin: 6px 0 8px;
    color: #494949;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    letter-spacing: .7px;
}

/* Responsive */
@media screen and (max-width: 700px) {
    .dt-title {
        font-size: 32px;
    }
    .dt-description {
        margin: 48px 0 0;
        font-size: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Contact.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,kBAAkB;;AAEtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;IAC/B,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;AACA,iBAAiB;AACjB;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[".doctor-section {\n    padding: 32px;\n    text-align: center;\n    background-color:white;\n}\n.dt-title-content {\n    margin: 0 0 64px 0;\n}\n.dt-title {\n    font-family: 'Inter', sans-serif;\n    font-size: 40px;\n    font-weight: bold;\n    letter-spacing: .7px;\n}\n.dt-title > span {\n    position: relative;\n\n}\n.dt-title span::before {\n    content: '';\n    position: absolute;\n    width: 64%;\n    height: 4px;\n    background-color: #9D2553;\n    border-radius: 8px;\n    left: 18%;\n    bottom: -12px;\n}\n.dt-description {\n    margin: 65px 295px ;\n    text-align: center;\n    color: rgb(77, 75, 75);\n    font-family: Inter , sans-serif;\n    font-size: 20px;\n    letter-spacing: .8px;\n    line-height: 1.8rem;\n}\n/* Doctor Cards */\n.dt-cards-content {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    gap: 32px;\n}\n.dt-card {\n    width: 332px;\n    height: 400px;\n    gap: 32px;\n    text-align: left;\n    font-family: 'Rubik', sans-serif;\n}\n.dt-card-img {\n    width: 90%;\n    height: 275px;\n    background-position: center;\n    border-radius: 20px;\n}\n.dt-card-name {\n    margin: 12px 0 0 0;\n    font-size: 22px;\n    font-weight: bold;\n    letter-spacing: .7px;\n}\n.dt-card-phone {\n    margin: 6px 0 8px;\n    color: #494949;\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n    letter-spacing: .7px;\n}\n.dt-card-mail {\n    margin: 6px 0 8px;\n    color: #494949;\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n    letter-spacing: .7px;\n}\n\n/* Responsive */\n@media screen and (max-width: 700px) {\n    .dt-title {\n        font-size: 32px;\n    }\n    .dt-description {\n        margin: 48px 0 0;\n        font-size: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
